import type { DoctorInstructionPriority, DoctorInstructionStatus } from './types';

/**
 * The tag colours a doctor instruction is read by, in one place.
 *
 * The queue is where the office decides one and the notification modal is where
 * they are told one exists; the same instruction must not be gold in one and
 * blue in the other.
 */
export const INSTRUCTION_STATUS_COLOR: Record<DoctorInstructionStatus, string> = {
  PROCESSING: 'gold',
  HANDLED: 'green',
  NOT_HANDLED: 'red',
};

export const INSTRUCTION_PRIORITY_COLOR: Record<DoctorInstructionPriority, string> = {
  LOW: 'default',
  NORMAL: 'blue',
  HIGH: 'red',
};

/**
 * The colour for a value that arrived as a plain string.
 *
 * Notification metadata types `priority` and `status` as `string` — the backend
 * stores them in free-form JSONB, so the generated client cannot narrow them.
 * An unrecognised value gets no colour and the caller renders no tag: naming it
 * would mean either inventing a label or printing the raw enum value, and
 * `doctor-instruction-priority-<unknown>` renders as the i18n key itself.
 */
export const instructionPriorityColor = (value?: string | null): string | undefined =>
  value && value in INSTRUCTION_PRIORITY_COLOR
    ? INSTRUCTION_PRIORITY_COLOR[value as DoctorInstructionPriority]
    : undefined;

export const instructionStatusColor = (value?: string | null): string | undefined =>
  value && value in INSTRUCTION_STATUS_COLOR ? INSTRUCTION_STATUS_COLOR[value as DoctorInstructionStatus] : undefined;
